import { useObject } from 'react-firebase-hooks/database'
import { firebaseDb, getRefreshDb, getOnlineStatusDb } from '../firebaseConfig'



function useRefresh(currentUser) {
  
  const refreshRef = getRefreshDb(currentUser.id)
  const statusRef = getOnlineStatusDb(currentUser.id)

  const [onlineSnapshot, onlineLoading, onlineError] = useObject(firebaseDb.ref(statusRef))
  const [snapshot, loading, error] = useObject(firebaseDb.ref(refreshRef))
  if (!currentUser.id) return

  // Remote-triggered refresh: reload ONLY when the admin flag is confirmed.
  // Never reload while either Firebase read is still loading or has errored —
  // a transient network failure must not force a reload.
  if (loading || error || onlineLoading || onlineError) return

  if (snapshot && snapshot.val() === "yes" && onlineSnapshot && onlineSnapshot.val()) {
    window.location.reload()
  }
}

export { useRefresh }
